import React, { useState } from 'react';
import { FiTruck } from 'react-icons/fi';
import Header from '../../layouts/Header';
import Filter from '../../helpers/filter/Filter';
import CreateTruck from '../../features/creates/truck/Truck';
import Create from '../../helpers/panel/Create';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { RiListCheck } from 'react-icons/ri';
import { VscSearch } from 'react-icons/vsc';
import classes from '../../assets/Global.module.css';


function Truck() {
  const [filterValue, setFilterValue] = useState('');

  const navigate = useNavigate();
  const pathName = useLocation().pathname.split('/').slice(-1)[0];

  return (
    <>
      <h1>Trucks</h1>
      <Header>
        <div>
          <button onClick={() => Create(<CreateTruck />)}>
            <FiTruck />
            <span>Create a Truck</span>
          </button>
          <button
            onClick={() => navigate('/asset/truck')}
            className={pathName === 'truck' ? classes.buttonActive : ''}
          >
            <RiListCheck />
            <span>Truck Board</span>
          </button>
          <button
            onClick={() => navigate('/asset/truck/search')}
            className={pathName === 'search' ? classes.buttonActive : ''}
          >
            <VscSearch />
            <span>Search Trucks</span>
          </button>
        </div>
        <div>
          <Filter
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder="Filter trucks"
          />
        </div>
      </Header>
      <Outlet context={filterValue} />
    </>
  );
}

export default Truck;
